import { createContext } from 'react'

import { DropzoneVariant } from '../componentStyles/Dropzone.style'
import type { Context as TContext } from './types'
import { _getInputProps, _getRootProps, _noOp } from './utils'

// Create ref objects that work with react-dropzone's strict typing
const createRef = <T>() => ({ current: null }) as React.RefObject<T>

export const contextDefault: TContext = {
  acceptedFiles: [],
  currentVariant: DropzoneVariant.Default,
  dropzoneState: {
    acceptedFiles: [],
    dragFileRejections: [],
    fileRejections: [],
    getInputProps: _getInputProps,
    getRootProps: _getRootProps,
    inputRef: createRef<HTMLInputElement>(),
    isDragAccept: false,
    isDragActive: false,
    isDragGlobal: false,
    isDragReject: false,
    isDragUnknown: false,
    isProcessing: false,
    isFileDialogActive: false,
    isFocused: false,
    open: _noOp,
    rootRef: createRef<HTMLElement>(),
  },
  potentialDuplicatePaths: [],
  props: {
    dropzoneProps: {},
    maxFileSize: 1024 * 1024 * 25, // 25MB
    onFileChange: _noOp,
    coverPage: null,
  },
  ref: { current: null },
  fileRejections: [],
  resetAllState: _noOp,
  setCurrentVariant: _noOp,
  totalSize: 0,
  updateFiles: _noOp,
  setFiles: _noOp,
  coverPage: null,
}

export const Context = createContext<TContext>(contextDefault)
